import * as Encounter from './encounter';
import * as Patient from './patient';
import * as Practice from './practice';
import * as User from './user';
import * as ProviderProfile from './providerProfile';

export enum DigitalCheckInFailureReason {
  AppointmentNotFound = 'APPOINTMENT_NOT_FOUND',
  DigitalCheckInEncounterNotFound = 'DIGITAL_CHECK_IN_ENCOUNTER_NOT_FOUND',
  AuthCodeExpired = 'AUTH_CODE_EXPIRED',
  FailedToUpdateAppointmentStatus = 'FAILED_TO_UPDATE_APPOINTMENT_STATUS',
  IneligbleForDigitalCheckIn = 'INELIGIBLE_FOR_DIGITAL_CHECK_IN',
  PatientUnauthorizedForDigitalCheckIn = 'PATIENT_UNAUTHORIZED_FOR_DIGITAL_CHECK_IN',
  Unknown = 'UNKNOWN', // This is a catch-all for any other error
}

export interface DigitalCheckInDetails {
  appointmentStatus: Encounter.AppointmentStatus | null;
  encounter: Pick<
    Encounter.Encounter,
    'arrivalTime' | 'startTime' | 'patientDirections' | 'patientInstructions'
  >;
  patient: Pick<
    Patient.Patient,
    'firstName' | 'preferredFirstName' | 'preferredLanguage'
  >;
  provider: Pick<
    User.User,
    'firstName' | 'lastName' | 'suffix' | 'previsitImageUrl' | 'prefix'
  > & { specialties: NonNullable<ProviderProfile.Profile['specialties']> | [] };
  practice: Pick<
    Practice.Practice,
    'name' | 'address' | 'city' | 'state' | 'zip'
  >;
  practicePreference: {
    digitalArrivalCustomContent: {
      [key: string]: string;
    };
    digitalArrivalIdentificationConfirmationRequired: boolean;
  };
}
